module.exports = __webpack_public_path__ + "img/58.50fb2d6c.jpg";